import {
  ofType
} from 'redux-observable';

import {
  ajax
} from "rxjs/ajax";

import { of } from 'rxjs';

import {
  map,
  switchMap,
  catchError,
} from 'rxjs/operators';

import {
  FETCH_BIGGEST_MOVERS,
  SET_BIGGEST_MOVERS,
  FETCH_BIGGEST_MOVERS_ERROR,
} from '../constants';

const biggestMovers = (action$, state$) => action$.pipe(
  ofType(FETCH_BIGGEST_MOVERS),
  switchMap(() =>
    ajax({
      url: `${state$.value.auth.server}/report/trends?since=${
          encodeURIComponent(state$.value.home.sinceDate)
        }&until=${
          encodeURIComponent(state$.value.home.untilDate)
        }&prevSince=${
          encodeURIComponent(state$.value.home.prevSinceDate)
        }&prevUntil=${
          encodeURIComponent(state$.value.home.prevUntilDate)
        }&v=${
          process.env.REACT_APP_VERSION
        }`,
      headers: {
        Authorization: state$.value.auth.token,
      },
      responseType: 'json',
      crossDomain: true,
    }).pipe(
      map(response => {
        return ({
          type: SET_BIGGEST_MOVERS,
          data: response.response,
        })
      }),
      catchError(error => of({
        type: FETCH_BIGGEST_MOVERS_ERROR,
        error,
      }))
    ),
  )
);

export default biggestMovers;
